export default {
  methods: {
    // 传入单个价格计划 判断是否违背
    iswb (i) {
      return (this.pageCtrl.isStart && this.model._policy.clzcJe && this.compareClbzPrice(i)) || 
      (this.model._policy.gkfs && this.model._policy.gkfs == 1 && this.model._ccsqPattern.checked && ((i.firstPrice - this.model._ccsqPattern.fyys / this.model._ccsqPattern.fjs) < 0))
    },
    // 传入单个价格计划 判断可否预订
    canbook (i) {
      return !this.model._policy.clzcJe || 
              this.model.tripType == 2 || 
              (this.model._policy.clzcJe && this.model._policy.gkfs && this.model._policy.gkfs == 2 && !this.compareClbzPrice(i)) || 
              this.model._policy.gkfs && this.model._policy.gkfs == 1
    },
    // 获取和差标比较的价格
    // 主要根据是否包含服务费 如果包含，根据服务费是按单/按间夜算，再跟差标比较
    // 当销售价设置是按单收，有可能除不尽，所以按总的价格和总的差标比较
    // 当前价格比差标大时返回 true
    compareClbzPrice (i) {
      let nightlyRates = i.nightlyRates,
        chargeType = i.chargeMode,
        fwfSum = i.totalFwf, // 后台计算单间 总夜的服务费
        priceSum = 0

      if (nightlyRates) {
        nightlyRates.forEach(nightly => {
          priceSum += nightly.salePrice
        })
        priceSum *= this.model._roomNum
      }

      if (this.model._policy.clzcBhFwf == '1') {
        if (chargeType == '1') {
          priceSum += fwfSum * this.model._roomNum
        } else if (chargeType == '2') {
          priceSum += fwfSum
        }
      }

      // console.log(`当前差标总额：${this.model._policy.totalClzcJe}，当前订单价格：${priceSum}`)

      return priceSum > this.model._policy.totalClzcJe
    }
  }
}
